import CoordinateDisplay from './coordinate-display-bar';
import CoordinateInteraction from './coordinate-interaction-bar';
import bundle from './bundle';

const plugin = {
  pluginName: 'PositionText',
  enabled: true,
  bundle: bundle,
  components:[{
    component: CoordinateDisplay,
    region: 'lower-right-toolbar',
    sortOrder: 10
  },{
    component: CoordinateInteraction,
    region: 'lower-right-toolbar',
    sortOrder: 20
  }]
}

export default plugin;